var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecreacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192.8 192.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#59595c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.41,59.77a3.77,3.77,0,0,0-5.25.89l-.08.11A3.77,3.77,0,0,0,112,66a3.73,3.73,0,0,0,2.17.69,3.78,3.78,0,0,0,3.08-1.58l.07-.11A3.78,3.78,0,0,0,116.41,59.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.83,70.44a3.77,3.77,0,0,0-5.3-.52A46.65,46.65,0,0,1,84.86,79a3.77,3.77,0,0,0,1,7.41,3.6,3.6,0,0,0,1-.13,54.26,54.26,0,0,0,20.51-10.54A3.77,3.77,0,0,0,107.83,70.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.51,85.28a11.31,11.31,0,0,0-11.3,11.3v1.88A32.07,32.07,0,0,1,143.65,130a18,18,0,0,0,3.12-10.16v-2.62a18.16,18.16,0,0,0-36.31,0v2.62a18.07,18.07,0,0,0,3,9.93A32.06,32.06,0,0,1,88.07,98.46V96.58a11.3,11.3,0,1,0-22.59,0v1.88A54.16,54.16,0,0,0,70,120.33H44.41V82.4a3.77,3.77,0,0,0-2.73-3.62A47.28,47.28,0,0,1,7.53,33.51V31.63a3.77,3.77,0,0,1,7.53,0v1.88A39.58,39.58,0,0,0,54.6,73.05H72.73a39.58,39.58,0,0,0,39.54-39.54V31.63a3.77,3.77,0,0,1,7.53,0v1.88a46.9,46.9,0,0,1-3.1,16.81,3.77,3.77,0,0,0,7,2.7,54.24,54.24,0,0,0,3.6-19.51V31.63a11.3,11.3,0,0,0-22.6,0v1.88A32,32,0,0,1,78.17,65.05a18,18,0,0,0,3.12-10.16V52.27a18.15,18.15,0,0,0-36.3,0v2.62a18,18,0,0,0,3,9.94A32.07,32.07,0,0,1,22.59,33.51V31.63A11.3,11.3,0,1,0,0,31.63v1.88A54.09,54.09,0,0,0,11.24,66.67,55.19,55.19,0,0,0,36.88,85.16v38.93a3.76,3.76,0,0,0,3.76,3.77h.69V189a3.77,3.77,0,0,0,7.53,0V127.86H74.08q1.23,1.92,2.64,3.75c.25.33.5.64.76,1V189A3.77,3.77,0,0,0,85,189V140.27a55.07,55.07,0,0,0,17.34,9.84V189a3.77,3.77,0,0,0,7.53,0V147.35a3.76,3.76,0,0,0-2.73-3.62A47.29,47.29,0,0,1,73,98.46V96.58a3.77,3.77,0,1,1,7.53,0v1.88A39.59,39.59,0,0,0,120.08,138H138.2a39.59,39.59,0,0,0,39.54-39.54V96.58a3.77,3.77,0,1,1,7.53,0v1.88A47.14,47.14,0,0,1,150.34,144a3.77,3.77,0,0,0-2.8,3.64v27.26a3.77,3.77,0,1,0,7.53,0V150.4A54.69,54.69,0,0,0,192.8,98.46V96.58A11.31,11.31,0,0,0,181.51,85.28Zm-129-33a10.62,10.62,0,0,1,21.24,0v2.62a10.62,10.62,0,0,1-21.24,0Zm86.72,67.57a10.63,10.63,0,0,1-21.25,0v-2.62a10.63,10.63,0,0,1,21.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154,186.38a3.77,3.77,0,1,0,1.1,2.66A3.8,3.8,0,0,0,154,186.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.14,140.84a3.76,3.76,0,0,0-3.77,3.76V189a3.77,3.77,0,0,0,7.53,0V144.6A3.76,3.76,0,0,0,63.14,140.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.48,30.88a3.76,3.76,0,0,0-3.76,3.76v4.69a3.77,3.77,0,0,0,7.53,0V34.64A3.77,3.77,0,0,0,175.48,30.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.48,53.31a3.76,3.76,0,0,0-3.76,3.77v4.68a3.77,3.77,0,0,0,7.53,0V57.08A3.77,3.77,0,0,0,175.48,53.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189,44.44h-4.68a3.77,3.77,0,1,0,0,7.53H189a3.77,3.77,0,0,0,0-7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.61,44.44h-4.68a3.77,3.77,0,1,0,0,7.53h4.68a3.77,3.77,0,0,0,0-7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.8,0A3.77,3.77,0,0,0,79,3.77V8.45a3.77,3.77,0,0,0,7.53,0V3.77A3.76,3.76,0,0,0,82.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.8,22.43A3.77,3.77,0,0,0,79,26.2v4.68a3.77,3.77,0,0,0,7.53,0V26.2A3.76,3.76,0,0,0,82.8,22.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.35,13.56H91.67a3.77,3.77,0,0,0,0,7.53h4.68a3.77,3.77,0,1,0,0-7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.92,13.56H69.24a3.77,3.77,0,0,0,0,7.53h4.68a3.77,3.77,0,1,0,0-7.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecreacion);
export default __webpack_public_path__ + "static/media/recreacion.45ae0ac556e648a90987876c3cb4e889.svg";
export { ForwardRef as ReactComponent };